import React, { Component } from 'react';
import Chart from "react-apexcharts";
import axios from 'axios'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';

export class TripCostchart extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "pie"
                },
                labels: ['Single trip cost', 'Couple trip cost', 'Profit'],
                legend: { position: 'bottom' },
            },
            series: [],
            isLoaded: false,
            filterDateTo: '',
            shipments:[]
        };

        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(data) {
        this.setState((prevState) => ({
            series: data
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        }
    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const token = localStorage.getItem("authTokenLoop");
        const dataUrl = API_URL + "/Bi_dashboard_tcs"

        axios({
            method: 'post',
            url: dataUrl,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + token,
            },
        }).then((response) => {
            if (response.data.success) {
                console.log(response.data.data);
                const dataArray = [Math.round(response.data.data.single_trip_cost), Math.round(response.data.data.couplt_trip_cost), Math.round(response.data.data.profit)]
                console.log(dataArray)
                const shipment_data = response.data.shipment_wise_cost;
                this.setState({shipments:shipment_data})
                this.setState({ series: [] })
                this.setState({
                    options: {
                        chart: { type: "pie" }, labels: ['Single trip cost', 'Couple trip cost', 'Profit'], legend: { position: 'bottom' },
                        dataLabels: {
                            enabled: true,
                            formatter: function (val, opts) {
                                let total = opts.w.config.series[opts.seriesIndex];
                                return `${val.toFixed(1)}% (Rs.${total}/=)`;
                            },
                        }
                    }
                })

                this.updateState(dataArray)
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const formData = new FormData();
        formData.append('filter_date', newToDate);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();

        var currentDate = new Date();
        var currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDate = currentDate.toISOString().split('T')[0];

        formData.append('filter_date', formattedDate);
        this.setState({ filterDateTo: formattedDate })
        this.getData(formData);
    }

    formatCurrency(amount) {
        const formattedAmount = new Intl.NumberFormat('en-IN').format(amount);
        return `Rs.${formattedAmount}/=`;
    }

    render() {
        return (
            <div className={`card col-12 m-5`} style={{ height: '60Vh' }}>
                <div className='card-header border-0 pt-4'>
                    <div className='row'>
                        <div className='col-8'>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bold fs-3 mb-1'>
                                    Trip Cost Saving
                                    <br /> <span style={{ color: '#A3A5A6' }}>{this.state.filterDateTo}</span>
                                </span>
                            </h3>
                        </div>
                        <div className='col-2'>
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'
                                style={{ width: '7vh' }}>
                                <i className='fas fa-filter mx-1'></i> Filter
                            </button>

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-2 ps-10'>
                            <ExcelExport data={this.state.shipments} fileName="Trip Cost Saving" />
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-4'>
                            <div id='loader' className={this.state.isLoaded == true && 'd-none'} style={{ height: "100%", width: "150%" }}>
                                <Circles
                                    height="100%"
                                    width="40%"
                                    color="#EA1C26"
                                    ariaLabel="circles-loading"
                                    wrapperStyle={{ padding: "15% 0", marginLeft: "16%" }}
                                    wrapperClass=""
                                    visible={true}
                                />
                            </div>
                            <div className={!this.state.isLoaded == true && 'd-none'} style={{ height: "32vh" }}>
                            <Chart
                                options={this.state.options}
                                series={this.state.series}
                                type="pie"
                                width="100%"
                                height="150%"
                            />
                            </div>
                        </div>
                        <div className='col-8' style={{height: "200px", overflow: "auto" }}>
                            <table className='table table-bordered' style={{ border: '1px solid black'}}>
                                <thead>
                                    <tr style={{ backgroundColor: '#DBDEE0' }}>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Date</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Shipment #</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Outcome Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.shipments.map((record) => (
                                    <tr key={record.shipment_number}>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.date}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.shipment}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{(()=>{
                                            return this.formatCurrency(record.profit)
                                        })()}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}